var _defs, _polyline, _polyline2, _line, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.98 8.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0b5ed6;\n        stroke-miterlimit: 10;\n        stroke-width: .3px;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.04 7.39 4.16 7.39 4.16 7.39"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.04 6.14 4.16 6.14 4.16 6.14"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.04,
    y1: 4.75,
    x2: 2.76,
    y2: 4.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.67.81V.21s-.03-.06-.06-.06H.22s-.06.03-.06.06v8.12s0,.03,0,.04c.01.01.02.02.04.02h0l5.41-.07s.06-.03.06-.06v-2.58s-.07.01-.11.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.57,4.51c.23-.37.37-.8.37-1.27,0-1.32-1.07-2.39-2.39-2.39s-2.39,1.07-2.39,2.39,1.07,2.39,2.39,2.39c.57,0,1.08-.21,1.49-.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.67,4.87s-.01,0-.02,0c-.42-.15-.79-.39-1.07-.71-.25-.29-.42-.62-.46-.92-.04-.3.05-.61.23-.82.16-.18.37-.28.62-.28.38,0,.56.2.7.38.13-.18.32-.38.7-.38.25,0,.46.1.62.28.18.21.27.51.23.82-.04.3-.2.63-.46.92-.28.32-.65.57-1.07.71,0,0-.01,0-.02,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.52,4.39l2.19,2.02c.15.14.15.38,0,.55h0c-.15.17-.4.19-.55.05l-2.19-2.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/Icon 10.7208371413ea4a990138deacdb88c1e5.svg";
export { ForwardRef as ReactComponent };